import { BellIcon } from '@icons';
import { Link } from 'react-router-dom';
import { css, styled } from 'styled-components';

export const Header = styled.header`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  padding: ${({ theme }) => theme.sizes.md} ${({ theme }) => theme.sizes.xl};
  background-color: ${({ theme }) => theme.colors.primary600};
  flex-shrink: 0;
  min-height: 72px;
  position: relative;
  z-index: 100;
  overflow: visible;

  @media (max-width: ${({ theme }) => theme.breakpoints.mobile}) {
    align-items: center;
    min-height: auto;
    padding: 10px ${({ theme }) => theme.sizes.sm};
    gap: ${({ theme }) => theme.sizes.xs};
  }
`;

export const HeaderLeft = styled.div`
  color: white;
  font-size: ${({ theme }) => theme.sizes.lg};
  font-weight: 600;
  white-space: nowrap;

  @media (max-width: ${({ theme }) => theme.breakpoints.mobile}) {
    font-size: ${({ theme }) => theme.sizes.md};
  }
`;

export const HeaderText = styled.span`
  color: white;
  font-size: ${({ theme }) => theme.sizes.sm};
  font-weight: 400;
  white-space: nowrap;

  @media (max-width: ${({ theme }) => theme.breakpoints.mobile}) {
    font-size: 11px;
  }
`;

export const LogoVale = styled.img`
  width: 93px;
  height: 35px;
  margin-bottom: 9px;
  flex-shrink: 0;

  @media (max-width: ${({ theme }) => theme.breakpoints.mobile}) {
    width: 64px;
    height: auto;
    margin-bottom: 0;
  }
`;

export const LogoNtt = styled.img`
  margin-left: -15px;
  flex-shrink: 0;

  @media (max-width: ${({ theme }) => theme.breakpoints.mobile}) {
    margin-left: 0;
    height: 18px;
    width: auto;
  }
`;

export const UserAvatar = styled.img`
  width: 32px;
  height: 32px;
`;

export const HeaderRight = styled.div`
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.sizes.xs};
  flex-shrink: 0;
  align-self: center;
`;

export const HeaderBellButton = styled.button`
  background: none;
  border: none;
  cursor: pointer;
  padding: ${({ theme }) => theme.sizes.xs};
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  transition: opacity 0.2s;

  &:hover {
    opacity: 0.85;
  }
`;

export const HeaderBellIcon = styled(BellIcon)`
  width: 24px;
  height: 24px;
`;

export const AvatarMenuWrapper = styled.div`
  position: relative;
  display: flex;
  align-items: center;
`;

export const AvatarMenuTrigger = styled.button`
  padding: ${({ theme }) => theme.sizes.xs};
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  background: none;
  border: none;
  cursor: pointer;
  border-radius: 50%;
  transition: opacity 0.2s;

  &:hover {
    opacity: 0.85;
  }
`;

export const MenuPopupContainer = styled.div`
  position: absolute;
  top: calc(100% + 8px);
  right: 0;
  left: auto;
  padding: 7px 5px;
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.sizes.xs};
  background-color: ${({ theme }) => theme.colors.primary600};
  border-radius: 14px;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.18);
  z-index: 300;

  &::before {
    content: '';
    position: absolute;
    top: -9px;
    right: 12px;
    left: auto;
    transform: none;
    width: 0;
    height: 0;
    border-left: 10px solid transparent;
    border-right: 10px solid transparent;
    border-bottom: 10px solid ${({ theme }) => theme.colors.primary600};
  }

  @media (max-width: ${({ theme }) => theme.breakpoints.mobile}) {
    top: calc(100% + 6px);
    right: 0;
  }
`;

const menuRowStyles = css`
  display: block;
  width: 180px;
  margin: 0;
  padding: 8px 0px;
  border: none;
  background: none;
  text-align: center;
  text-decoration: none;
  font-size: ${({ theme }) => theme.sizes.sm};
  font-weight: 400;
  font-family: ${({ theme }) => theme.fonts.primary};
  color: ${({ theme }) => theme.colors.neutral};
  cursor: pointer;
  border-radius: 8px;
  line-height: 1.35;
  transition: background-color 0.15s ease;

  &:hover {
    background-color: ${({ theme }) => theme.colors.primary500};
  }

  @media (max-width: ${({ theme }) => theme.breakpoints.mobile}) {
    width: 140px;
    font-size: 13px;
  }
`;

export const MenuPopupItem = styled.button`
  ${menuRowStyles}
`;

export const MenuPopupNavLink = styled(Link)`
  ${menuRowStyles}
`;

export const MenuPopupExternalLink = styled.a`
  ${menuRowStyles}
`;
